var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 651,
    height: 570,
    viewBox: "0 0 651 570",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_44_2774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.727 132.973C421.582 132.973 383.573 154.578 362 188.528C340.427 154.578 302.418 132.973 259.273 132.973C191.473 132.973 136 188.528 136 256.428C136 378.855 362 503.338 362 503.338C362 503.338 588 379.883 588 256.428C588 188.528 532.527 132.973 464.727 132.973Z",
    fill: "url(#paint0_linear_44_2774)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M383.793 344.453V349.589C383.793 349.612 383.802 349.635 383.819 349.651C383.836 349.668 383.858 349.677 383.882 349.677H397.274C397.297 349.677 397.32 349.668 397.337 349.651C397.353 349.635 397.363 349.612 397.363 349.589V344.407C397.363 338.138 394.871 332.126 390.436 327.694C386.001 323.261 379.985 320.771 373.713 320.771C363.486 320.771 353.678 324.831 346.447 332.058C339.215 339.285 335.153 349.087 335.153 359.308C335.145 361.482 335.57 363.636 336.403 365.645C337.237 367.653 338.461 369.476 340.006 371.007L353.02 384.009C354.551 385.545 356.371 386.764 358.375 387.597C360.379 388.429 362.527 388.858 364.698 388.859H404.584C409 388.858 413.234 387.104 416.356 383.983C419.478 380.862 421.232 376.629 421.232 372.216V264.148C421.232 258.35 418.457 252.781 413.562 249.676C411.132 248.121 408.335 247.233 405.452 247.099C402.57 246.965 399.702 247.592 397.138 248.915L363.717 265.997C363.293 266.209 362.826 266.319 362.353 266.319C361.879 266.319 361.412 266.209 360.989 265.997L327.576 248.915C325.011 247.592 322.143 246.965 319.26 247.099C316.377 247.233 313.579 248.121 311.148 249.676C306.257 252.795 303.506 258.345 303.506 264.148V359.761C303.504 363.697 304.907 367.504 307.462 370.498L320.541 385.825C321.354 386.779 322.364 387.545 323.502 388.071C324.64 388.597 325.879 388.869 327.132 388.868C328.352 388.867 329.546 388.517 330.573 387.859C331.6 387.201 332.417 386.264 332.928 385.157C333.439 384.05 333.622 382.82 333.456 381.612C333.29 380.404 332.781 379.269 331.99 378.341L317.795 361.703C317.337 361.163 317.085 360.478 317.085 359.77V263.635C317.084 263.124 317.214 262.622 317.464 262.176C317.713 261.73 318.073 261.356 318.508 261.089C318.944 260.822 319.441 260.672 319.952 260.653C320.462 260.633 320.97 260.745 321.424 260.978L354.851 278.06C357.185 279.252 359.769 279.873 362.39 279.873C365.011 279.873 367.595 279.252 369.929 278.06L403.356 260.978C403.81 260.745 404.318 260.633 404.828 260.653C405.339 260.672 405.836 260.822 406.272 261.089C406.707 261.356 407.067 261.73 407.316 262.176C407.566 262.622 407.696 263.124 407.695 263.635V372.216C407.693 373.031 407.368 373.811 406.793 374.387C406.217 374.964 405.436 375.289 404.622 375.293H364.772C363.949 375.292 363.159 374.965 362.577 374.382L349.633 361.456C349.054 360.876 348.728 360.09 348.727 359.271C348.726 355.997 349.371 352.755 350.624 349.729C351.878 346.704 353.715 343.956 356.031 341.64C358.347 339.325 361.097 337.488 364.124 336.235C367.151 334.982 370.395 334.337 373.671 334.337C375 334.337 376.316 334.599 377.544 335.107C378.772 335.616 379.888 336.361 380.828 337.3C381.768 338.24 382.514 339.355 383.023 340.582C383.531 341.809 383.793 343.125 383.793 344.453Z",
    fill: "url(#paint1_linear_44_2774)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M350.768 299.929C350.768 294.946 346.728 290.906 341.745 290.906C336.762 290.906 332.722 294.946 332.722 299.929C332.722 304.912 336.762 308.952 341.745 308.952C346.728 308.952 350.768 304.912 350.768 299.929Z",
    fill: "#EDEDED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M392.015 299.929C392.015 294.946 387.783 290.906 382.563 290.906C377.342 290.906 373.11 294.946 373.11 299.929C373.11 304.912 377.342 308.952 382.563 308.952C387.783 308.952 392.015 304.912 392.015 299.929Z",
    fill: "#EDEDED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M350.768 299.929C350.768 294.946 346.728 290.906 341.745 290.906C336.762 290.906 332.722 294.946 332.722 299.929C332.722 304.912 336.762 308.952 341.745 308.952C346.728 308.952 350.768 304.912 350.768 299.929Z",
    fill: "url(#paint2_linear_44_2774)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M350.768 299.929C350.768 294.946 346.728 290.906 341.745 290.906C336.762 290.906 332.722 294.946 332.722 299.929C332.722 304.912 336.762 308.952 341.745 308.952C346.728 308.952 350.768 304.912 350.768 299.929Z",
    fill: "url(#paint3_linear_44_2774)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M392.015 299.929C392.015 294.946 387.783 290.906 382.563 290.906C377.342 290.906 373.11 294.946 373.11 299.929C373.11 304.912 377.342 308.952 382.563 308.952C387.783 308.952 392.015 304.912 392.015 299.929Z",
    fill: "url(#paint4_linear_44_2774)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M392.015 299.929C392.015 294.946 387.783 290.906 382.563 290.906C377.342 290.906 373.11 294.946 373.11 299.929C373.11 304.912 377.342 308.952 382.563 308.952C387.783 308.952 392.015 304.912 392.015 299.929Z",
    fill: "url(#paint5_linear_44_2774)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_44_2774",
    x: 0.248749,
    y: 0.884911,
    width: 649.95,
    height: 568.315,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -36.7763,
    dy: -33.1136
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 49.4875
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.173487 0 0 0 0 0.0510251 0 0 0 0 0.0411247 0 0 0 0.457 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44_2774"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44_2774",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -16.5085,
    dy: -14.8643
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.1072
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.327581 0 0 0 0 0.264021 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_44_2774"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 16.5085,
    dy: 14.8643
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.1072
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.559496 0 0 0 0 0.164556 0 0 0 0 0.132627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_44_2774",
    result: "effect3_innerShadow_44_2774"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_2774",
    x1: 398.363,
    y1: 447.718,
    x2: 122.838,
    y2: 144.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E2F26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_2774",
    x1: 332.07,
    y1: 286.206,
    x2: 419.57,
    y2: 364.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBCE8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FB80AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40DED2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_44_2774",
    x1: 332.722,
    y1: 299.929,
    x2: 391.233,
    y2: 299.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBCE8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FB80AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40DED2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_44_2774",
    x1: 332.722,
    y1: 299.929,
    x2: 391.233,
    y2: 299.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBCE8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FB80AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40DED2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_44_2774",
    x1: 330.718,
    y1: 299.929,
    x2: 392.015,
    y2: 299.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBCE8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FB80AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40DED2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_44_2774",
    x1: 330.718,
    y1: 299.929,
    x2: 392.015,
    y2: 299.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBCE8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FB80AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40DED2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.e5c905fd932ea2e8ad22b578fc2f2d02.svg";
export { ForwardRef as ReactComponent };